// extracted by mini-css-extract-plugin
module.exports = {"customNavLink":"VizOptions_customNavLink__BY4mG"};